import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import '../../webcss/invoice.css';
import { POST_DMT_TRANSACTION_INVOICE, POST_FINO_TRANSACTION_INVOICE } from '../../Utils/appConstants';
import { getUTCToLocalDateTimeFormat } from '../../Utils/function';
import { dmtDetailStatus } from '../../Utils/Common';
import { postRequest } from '../../Utils/AppApi';

function Invoice(props) {
    const history = useHistory();
    const [apiName, setApiName] = useState('');
    const [idata, setData] = useState({});
    const [isPrintButton, setPrintButton] = useState(true);
    const [isDetail, setDetail] = useState([]);
    const [loading, setLoading] = useState(true);

    const { isPageView = false } = props;

    const print = () => {
        setPrintButton(false);
        setTimeout(() => {
            window.print();
            setPrintButton(true);
        }, 100);
    };

    const handleInvoice = (transactionId) => {
        setLoading(true);
        let payload = { transactionId };
        postRequest(`${apiName}`, payload, history)
            .then((response) => {
                if (response.success === true) {
                    setData(response.data || {});
                    setDetail(response.data?.dmttransactiondetails || []);
                } else {
                    setData({});
                    setDetail([]);
                }
            })
            .catch(() => {
                setData({});
                setDetail([]);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {

        if (props.transactionId?.startsWith('SF')) {

            setApiName(POST_FINO_TRANSACTION_INVOICE);

        } else {

            setApiName(POST_DMT_TRANSACTION_INVOICE);


        }
    }, []);

    useEffect(() => {
        if (apiName && props.transactionId) {
            handleInvoice(props.transactionId);
        }
    }, [apiName, props.transactionId]);

    if (loading) {
        return (
            <div className="compact-loading-invoice">
                <div className="compact-spinner-invoice"></div>
                <p>Loading receipt details...</p>
            </div>
        );
    }

    return (
        <div className="compact-invoice-container">
            {/* Compact Invoice Header */}
            <div className="compact-invoice-header">
                <div className="compact-brand">
                    <div className="compact-logo">
                        <img src="../logo.png" alt="AdminLTE Logo" className="brand-image" style={{ opacity: '.8' }} />

                        {/* <i className="fa fa-receipt"></i> */}
                    </div>

                </div>
                {/* <div className="compact-status">
                    <span className={`compact-status-dot ${idata?.txtStatus === 1 || idata?.txtStatus === 3 ? 'success' : 'pending'}`}></span>
                    <span className="compact-status-text">
                        {idata?.txtStatus === 1 || idata?.txtStatus === 3 ? 'Completed' : 'Processing'}
                    </span>
                </div> */}
                {/* <div className="compact-verification-item">
                    <span className="compact-verification-label">Printed On:</span>
                    <span className="compact-verification-value">
                        {new Date().toLocaleDateString()} {new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </span>
                </div> */}

                <div className="compact-brand-info">
                    <h4 className="compact-company-name">Customer Name : {idata?.dmtcustomerlists?.customerName || idata?.baneData?.customerName || 'N/A'}</h4>
                    <p className="compact-transaction-ref">Mobile : {idata?.dmtcustomerlists?.customerMobile || idata?.baneData?.customerMobile || 'N/A'}</p>
                    <p className="compact-transaction-ref">Date & Time : {getUTCToLocalDateTimeFormat(idata?.createdAt) || 'N/A'}</p>
                </div>
            </div>

            {/* Compact Info Grid */}
            <div className="compact-info-grid">
                {/* <div className="compact-info-card">
                    <div className="compact-card-header">
                        <i className="fa fa-user fa-sm"></i>
                        <h5>Customer</h5>
                    </div>
                    <div className="compact-card-body">
                        <div className="compact-info-row">
                            <span className="compact-info-label">Name:</span>
                            <span className="compact-info-value">{idata?.dmtcustomerlists?.customerName || idata?.finocustomerlists?.customerName || 'N/A'}</span>
                        </div>
                        <div className="compact-info-row">
                            <span className="compact-info-label">Mobile:</span>
                            <span className="compact-info-value">{idata?.dmtcustomerlists?.customerMobile || idata?.finocustomerlists?.customerMobile || 'N/A'}</span>
                        </div>
                        <div className="compact-info-row">
                            <span className="compact-info-label">Message:</span>
                            <span className="compact-info-value">{idata?.message || 'N/A'}</span>
                        </div>
                    </div>
                </div> */}

                <div className="compact-info-card">
                    <div className="compact-card-header">
                        <i className="fa fa-university fa-sm"></i>
                        <h5>Beneficiary</h5>
                        <span className={`compact-verification-value ${idata?.baneData?.isVerified ? 'verified' : 'unverified'}`}>
                            {/* <i className={`fa ${idata?.baneData?.isVerified ? 'fa-check-circle' : 'fa-clock'} fa-sm`}></i> */}
                            {idata?.baneData?.isVerified ? '(Verified)' : '(Pending Verification)'}
                        </span>
                    </div>
                    <div className="compact-card-body">
                        {/* 
                        <div className="compact-info-row">
                            <span className="compact-info-label">Bene Name:</span>
                            <span className="compact-info-value">{idata?.dmttransactiondetails?.responseData?[0].beneName || idata?.baneData?.beneName || 'N/A'}</span>
                        </div> */}

                        <div className="compact-info-row">
                            <span className="compact-info-label">Bene Name:</span>
                            {/* <span className="compact-info-value">
                                {idata?.dmttransactiondetails?.[0]?.responseData?.beneName ||
                                    idata?.baneData?.beneName ||
                                    'N/A'}
                            </span> */}
                            <span className="compact-info-value">
                                {idata?.dmttransactiondetails?.[0]?.responseData?.beneName ||
                                    idata?.baneData?.beneBankName || idata?.baneData1?.beneBankName ||
                                    idata?.baneData?.beneName ||
                                    idata?.baneData1?.beneName ||
                                    'N/A'}
                            </span>
                        </div>
                        <div className="compact-info-row">
                            <span className="compact-info-label">Bank:</span>
                            <span className="compact-info-value">{idata?.baneData?.bankName || 'N/A'}</span>
                        </div>
                        <div className="compact-info-row">
                            <span className="compact-info-label">Account:</span>
                            <span className="compact-info-value small">{idata?.baneData?.accountNumber || 'N/A'}</span>
                        </div>
                        <div className="compact-info-row">
                            <span className="compact-info-label">IFSC:</span>
                            <span className="compact-info-value small">{idata?.baneData?.ifscCode || 'N/A'}</span>
                        </div>
                    </div>
                </div>

                <div className="compact-info-card">
                    <div className="compact-card-header">
                        <i className="fa fa-store fa-sm"></i>
                        <h5>Outlet</h5>
                    </div>
                    <div className="compact-card-body">
                        <div className="compact-info-row">
                            <span className="compact-info-label">Name:</span>
                            <span className="compact-info-value">{idata?.userdetails?.outletName || 'N/A'}</span>
                        </div>
                        <div className="compact-info-row">
                            <span className="compact-info-label">Agent:</span>
                            <span className="compact-info-value">{idata?.userdetails?.firstName} {idata?.userdetails?.lastName}</span>
                        </div>
                        <div className="compact-info-row">
                            <span className="compact-info-label">Contact:</span>
                            <span className="compact-info-value">{idata?.userdetails?.mobile || 'N/A'}</span>
                        </div>

                        <div className="compact-info-row">
                            <span className="compact-info-label">Address:</span>
                            <span className="compact-info-value">{idata?.userdetails?.communicationAddress || 'N/A'}</span>
                        </div>
                    </div>
                </div>
            </div>
            {idata?.message && (
                <div className={`compact-message ${idata?.txtStatus === 1 || idata?.txtStatus === 3 ? 'success' : 'warning'}`}>
                    <i className={`fa ${idata?.txtStatus === 1 || idata?.txtStatus === 3 ? 'fa-check-circle' : 'fa-info-circle'} fa-sm`}></i>
                    <span>{idata?.message}</span>
                </div>
            )}

            {/* Transaction Table - More Compact */}
            {!idata?.isInsufficientFund && isDetail.length > 0 && (
                <div className="compact-transaction-section">
                    {/* <div className="compact-section-title">
                        <i className="fa fa-history fa-sm"></i>
                        <h5>{idata?.message}</h5>
                    </div> */}
                    <div className="compact-table">
                        <div className="compact-table-header">
                            <div className="compact-th">Date & Time</div>
                            <div className="compact-th">Txn ID</div>
                            <div className="compact-th">Bank RRN</div>
                            <div className="compact-th">Amount</div>
                            <div className="compact-th">Status</div>
                        </div>
                        {isDetail.map((el, i) => (
                            <div key={i} className="compact-table-row">
                                <div className="compact-td">
                                    {getUTCToLocalDateTimeFormat(el.updatedAt)}
                                </div>
                                <div className="compact-td">
                                    <span className="compact-amount">{el.transactionId}</span>
                                </div>
                                <div className="compact-td">
                                    <span className="compact-amount">{el.bank_ref_num}</span>
                                </div>
                                <div className="compact-td">
                                    <span className="compact-amount">₹{el.amount}</span>
                                </div>
                                <div className="compact-td">
                                    <span className={`compact-status-badge ${el.tx_status === 'SUCCESS' ? 'success' :
                                        el.tx_status === 'FAILED' ? 'failed' : 'pending'}`}>
                                        {dmtDetailStatus(el.tx_status)}
                                    </span>

                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}



            {/* Footer Actions */}
            <div className="compact-footer">
                <div className="compact-footer-note">
                    <i className="fa fa-info-circle fa-sm"></i>
                    Computer generated receipt - No signature required
                </div>

                <div className="compact-footer-actions">
                    {isPageView && isPrintButton && (
                        <button
                            onClick={print}
                            className="compact-print-btn"
                            title="Print receipt"
                        >
                            <i className="fa fa-print"></i>
                            Print Receipt
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Invoice;